<svg
	class="sparkline-svg"
	[attr.viewBox]="'0 0 ' + width() + ' ' + height()"
	preserveAspectRatio="none"
	(mousemove)="onMouseMove($event)"
	(mouseleave)="onMouseLeave()"
>
	@for (s of segments(); track s) {
		<path
			[attr.d]="s.dLine"
			[attr.stroke]="s.stroke"
			[attr.stroke-width]="strokeWidth()"
			fill="none"
			stroke-linecap="round"
		></path>
	}

	@if (hoverIndex() !== null && hoverX !== null && hoverY !== null) {
		<circle class="hover-dot" [attr.cx]="hoverX" [attr.cy]="hoverY" r="1.3"></circle>
		<g [attr.transform]="tooltipTransform">
			<rect class="tooltip-bg" [attr.width]="tooltipWidth - 4" height="15" rx="2" ry="2"></rect>
			<text class="tooltip-text" [attr.width]="tooltipWidth" x="3" y="11">{{ hoverValue }}</text>
		</g>
	}
</svg>
